import React, { useEffect, useState } from "react";
import { Box, Button, Chip, Grid2, Stack, useTheme, } from "@mui/material";
import TableComponent from "components/grid";
import { useNavigate, useParams } from "react-router-dom";
import PaginationComponent from "components/ui-components/PaginationComponent";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";
import { FaPlus } from "react-icons/fa6";
import AddMoteCarloSimulation from "./AddMoteCarloSimulation";
import { useGetAllMonteCarloSimulationQuery } from "store/slices/apis/monteCarloSimulationSlice";
import moment from "moment";
import { useDispatch } from "store";
import { closeSnackbar, openSnackbar } from "store/slices/snackbar";
import ResultMonteCarloSimulation from "./ResultMonteCarloSimulation";
import { usePermission } from "hooks/usePermission";
import { MONTE_CARLO_SIMULATION_CREATE, MONTE_CARLO_SIMULATION_VIEW, MONTE_CARLO_SIMULATION_RESULT } from "config";
import { ReactComponent as AddNewIcon } from "assets/PwC_Funct_Icons_Plus_Outline_Black_RGB.svg"
import { ReactComponent as CalendarIcon } from "assets/PwC_Funct_Icons_Calendar_Outline_Black_RGB.svg"


const AllMonteCarloSimulation = () => {
    const theme = useTheme();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const addMonteCarloAccess = usePermission(MONTE_CARLO_SIMULATION_CREATE);
    const viewMonteCarloAccess = usePermission(MONTE_CARLO_SIMULATION_VIEW);
    const viewResultMonteCarloAccess = usePermission(MONTE_CARLO_SIMULATION_RESULT);
    const { projectId } = useParams();

    const [pageSize, setPageSize] = useState(10);
    const [pageNumber, setPageNumber] = useState(1);

    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);

    const [filters, setFilters] = useState({
        fromDate: "",
        toDate: ""
    });

    const [isAddSimulation, setIsAddSimulation] = useState(false);
    const [isViewSimulation, setIsViewSimulation] = useState(false);
    const [isResultSimulation, setIsResultSimulatio] = useState(false);

    const [rowData, setRowData] = useState(null);

    const [allSimulationListData, setAllSimulationListData] = useState([]);

    const { data: allSimulationList, isLoading, isSuccess: allSimulationIsSuccess } = useGetAllMonteCarloSimulationQuery({
        projectId: projectId,
        fromDate: filters?.fromDate,
        toDate: filters?.toDate,
        page: pageNumber,
        pageSize: pageSize,
    });

    useEffect(() => {
        if (allSimulationIsSuccess) {
            setAllSimulationListData(allSimulationList?.data?.data)
        }
    }, [allSimulationList, allSimulationIsSuccess])

    const handleAddSimulation = () => {
        setIsAddSimulation(!isAddSimulation);
    }

    const handleView = (row) => {
        setIsViewSimulation((prev) => {
            const newState = !prev;
            setRowData(newState ? row : null);
            return newState;
        });
    }

    const CustomCalendarIcon = (props) => (
        <CalendarIcon {...props} style={{ width: 26, height: 26, fill: "#696969 ", stroke: "#696969", strokeWidth: 4 }} />
    );

    const handleResultView = (row) => {
        setIsResultSimulatio((prev) => {
            const newState = !prev;
            setRowData(newState ? row : null);
            return newState;
        });
    }

    const openNotification = async (msg, type = 'error') => {
        await dispatch(
            openSnackbar({
                open: true,
                message: msg,
                variant: 'alert',
                alert: {
                    color: type
                },
                close: false
            })
        );
        setTimeout(() => dispatch(closeSnackbar()), 3000);
    };

    const columns = [
        {
            name: "Simulation ID",
            field: "issueNumber",
            renderer(params) {
                return (
                    <Stack direction="row" spacing={1}>
                        {params?.simulationId &&
                            <Chip label={params?.simulationId} size="small" sx={{
                                fontSize: '12px',
                                '& .MuiChip-label': {
                                    paddingLeft: '8px',
                                    paddingRight: '8px',
                                    fontWeight: 600
                                }
                            }} />
                        }
                    </Stack>
                );
            }
        },
        {
            name: "Run Date",
            field: "runDate",
            renderer(params) {
                return (
                    <>
                        {params?.runDate
                            ? moment(params.runDate).format("DD/MM/YYYY")
                            : ""}
                    </>
                );
            },
        },
        {
            name: "No Of Iterations",
            field: "numberOfIterations",
        },
        {
            name: "Distribution method",
            field: "distributionMethod",
        },
        {
            name: "Status",
            field: "status",
        },
        {
            name: "Action",
            field: "action",
            option: {}
        },
    ];

    return (
        <>
            <Grid2 container spacing={2} sx={{ mt: "20px" }}>
                <Grid2 size={12}>
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: { xs: 'start', sm: 'center' },
                            justifyContent: "space-between",
                            flexDirection: { xs: 'column', sm: 'row' }
                        }}
                    >
                        <Stack
                            direction={{ xs: 'column', sm: 'row' }}
                            spacing={2}
                            sx={{
                                // flexGrow: 2,
                                alignItems: { xs: "stretch", sm: "center" },
                                width: { xs: '100%', sm: 'auto', },
                                "& .MuiStack-root": {
                                    paddingTop: "15px",
                                },
                            }}
                        >

                            <LocalizationProvider dateAdapter={AdapterDayjs} size="small">
                                <DemoContainer components={["DatePicker", "DatePicker"]}>
                                    <DatePicker
                                        label="From Date"
                                        value={fromDate}
                                        format="DD-MM-YYYY"
                                        onChange={(newValue) => setFromDate(newValue)}
                                        slots={{
                                            openPickerIcon: CustomCalendarIcon,
                                        }}
                                        slotProps={{
                                            textField: {
                                                sx: {
                                                    minWidth: 100,
                                                    "& .MuiOutlinedInput-input": {
                                                        padding: "10px",
                                                    },

                                                    "& .MuiInputLabel-root": {
                                                        top: "-6px",
                                                    },
                                                },
                                            },
                                            field: {
                                                clearable: true,
                                                onClear: () =>
                                                    setFilters({
                                                        fromDate: "",
                                                        toDate: toDate
                                                            ? dayjs(toDate).format("YYYY-MM-DD")
                                                            : "",
                                                    }),
                                            },
                                        }}
                                    />
                                </DemoContainer>
                            </LocalizationProvider>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DemoContainer components={["DatePicker", "DatePicker"]}>
                                    <DatePicker
                                        label="To Date"
                                        value={toDate}
                                        format="DD-MM-YYYY"
                                        clearable={true}
                                        onChange={(newValue) => setToDate(newValue)}
                                        slots={{
                                            openPickerIcon: CustomCalendarIcon,
                                        }}
                                        slotProps={{
                                            textField: {
                                                sx: {
                                                    minWidth: 100,
                                                    "& .MuiOutlinedInput-input": {
                                                        padding: "10px",
                                                    },

                                                    "& .MuiInputLabel-root": {
                                                        top: "-6px",
                                                    },
                                                },
                                            },
                                            field: {
                                                clearable: true,
                                                onClear: () =>
                                                    setFilters({
                                                        fromDate: fromDate
                                                            ? dayjs(fromDate).format("YYYY-MM-DD")
                                                            : "",
                                                        toDate: "",
                                                    }),
                                            },
                                        }}
                                    />
                                </DemoContainer>
                            </LocalizationProvider>
                            <Button
                                loading={isLoading}
                                onClick={() => {
                                    setFilters({
                                        fromDate: fromDate
                                            ? dayjs(fromDate).format("YYYY-MM-DD")
                                            : "",
                                        toDate: toDate ? dayjs(toDate).format("YYYY-MM-DD") : ""
                                    });
                                }}
                                size="large"
                                variant="outlined"
                                sx={{
                                    color: `${theme?.customSettings?.themeColor}`,
                                    border: `1px solid ${theme?.customSettings?.themeColor}`,
                                    background: "none",
                                    textTransform: "inherit",
                                    padding: "6px 15px",
                                    marginTop: "12px !important",
                                }}
                            >
                                Search
                            </Button>
                            <Button
                                loading={isLoading}
                                onClick={() => {
                                    setFromDate(null)
                                    setToDate(null)
                                    const clearedValues = Object.fromEntries(
                                        Object.keys(filters).map(key => [key, ""])
                                    );
                                    setFilters(clearedValues);
                                }}
                                size="large"
                                variant="outlined"
                                sx={{
                                    color: `${theme?.customSettings?.themeColor}`,
                                    border: `1px solid ${theme?.customSettings?.themeColor}`,
                                    background: "none",
                                    textTransform: "inherit",
                                    padding: "6px 15px",
                                    marginTop: "12px !important",
                                }}
                            >
                                Reset
                            </Button>
                        </Stack>
                        {addMonteCarloAccess &&
                            <Button
                                variant="contained"
                                //   startIcon={<FaPlus sx={{ marginBottom: "2px" }} />}
                                startIcon={<AddNewIcon style={{ height: "20px", width: "20px", fill: "#FFFFFF" }} />}
                                onClick={handleAddSimulation}
                                sx={{
                                    backgroundColor: `${theme?.customSettings?.themeColor}`,
                                    color: "#FFF",
                                    padding: "5px 20px",
                                    fontWeight: "500",
                                    textTransform: "none",
                                    fontSize: "16px",
                                    whiteSpace: "nowrap",
                                    marginTop: "11px",
                                    border: `1px solid ${theme?.customSettings?.themeColor}`,
                                    '&.Mui-disabled': {
                                        border: 'none'
                                    }
                                }}
                            >
                                New Simulation
                            </Button>
                        }
                    </Box>
                </Grid2>
                <Grid2 size={12} sx={{ mt: 2 }}>
                    <TableComponent
                        columns={columns
                            .map((col) =>
                                col.field === "action"
                                    ? {
                                        ...col,
                                        option: {
                                            ...col.option,
                                            view: viewMonteCarloAccess,
                                            result: viewResultMonteCarloAccess
                                        },
                                    }
                                    : col
                            )
                            .filter((col) => {
                                if (col.field !== "action") {
                                    return true;
                                } else {
                                    return Object.values(col.option).some((v) => v === true);
                                }

                            })}
                        data={allSimulationListData}
                        actionView={handleView}
                        actionResult={handleResultView}
                        type="border"
                        isLoading={isLoading}
                    />
                    {!isLoading && (
                        <Box sx={{ display: "flex", justifyContent: "end" }}>
                            <PaginationComponent
                                pageNumber={allSimulationList?.data?.pagination?.currentPage || 1}
                                totalPages={allSimulationList?.data?.pagination?.totalPages || 1}
                                onPageChange={setPageNumber}
                            />
                        </Box>
                    )}
                </Grid2>
            </Grid2>
            {isAddSimulation &&
                <AddMoteCarloSimulation open={isAddSimulation} cancel={handleAddSimulation} openNotification={openNotification} />
            }
            {isViewSimulation &&
                <AddMoteCarloSimulation open={isViewSimulation} cancel={handleView} rowData={rowData} isViewSimulation={isViewSimulation} />
            }
            {isResultSimulation &&
                <ResultMonteCarloSimulation open={isResultSimulation} cancel={handleResultView} rowData={rowData} openNotification={openNotification} publish={true} />
            }
        </>
    );
}

export default AllMonteCarloSimulation;
